import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    ...enLocale,
	model:{
		messagemin:'Please be reminded to provide all the required information.',
	},
    header: {
        p1: "Dear Customer:",
        p2: "Should you have any enquiries, please contact our Customer Services Department.",
        p3: "Customer Services Hotline:",
        p3_ph: "(852) 3971 6988",
        p4: "Toll Free Customer Services Hotline(For Mainland China):",
        p4_ph: "4001 206 046",
        p5: "Office Hour: 9:00 a.m. - 6:00 p.m.",
        p6: "Closed on Saturday, Sunday and Public Holidays",
        p7: "QMIS Official WeChat",
        p8: "QMIS Official Whatsapp",
    },
    allpage: {
		qtxbtxadd:'Please enter your residential address',
        qtxbtx: "Please be reminded to provide all the required information before proceeding to the next page.",
        ts30mintj: "Please fill-in and submit the Account Opening Application within 60 minutes, and the completed information will not be retained after the overtime.",
        queding: "CONFIRM",
        tishi: "Reminder",
        syserr: "Server Exception!",
        pleasechecknet: "request failed, pleasecheck the network!",
        wrongfile: "Upload error, the document must use PNG / JPG / JPEG format",
        filesizeeror: "Upload failed, photo cannot exceed 2M",
        xiuxintime: " is not an optional break！",
        yuyuesize: " is full, please choose another time.",
        kfcx: "Customer Service"
    },
    tabbar: {
        jbxx: "Basic Information",
        sgzk: "Employment Status",
        cwzk: "Financial Status",
        khsm: "Client Declaration",
        fxpg: "Risk Assessment",
        wjsc: "File Upload",
        ktzh: "Account Opening",
        yykh: "Appointment"
    },
    khxy: {
        tygxy: "I Agree",
        loading: "Trying to load the customer agreement for you"
    },
    login: {
		later:'',
		copyright:'© Copyright 2026 QMIS Financial Group. All rights reserved.',
        zysx:'Points to Note',
		cjwt:'FAQs',
		xgtk:'Terms of Use',
		jszy:'Technical Support',
		khjx:'Account Opening Tutorial',
		xgzl:'Related Information',
		leave:'Leave',
        klzh:'Account Opening',
		khzl:'Client Information',
		ywzk:'Employment / Business Status',
		tzgk:'Financial / Investment Profile',
		khsm:'Declaration and Signature by Client',
		fxpg:'Risk Assessment',
		wskh:'Account Opening (Online)',
        fanhui:'Return',
		chongzhi:'Reset',
		cucun:'Save',
		jixu:'Continue',
        step:" Step",
		email:'Email',
		plaletelephone:'Please enter the phone number',
		plaletelephoneweb:'Telephone number',
		plaletelephones:'Please Enter',
		verificationcode:'Code',
		fullname:'Full Name',
		telephone:'Telephone Number',
		submit:'Submit',
		submits:'Submit',
		khname:'Please complete the ( Red Wordings / Red Frame ) section',
        khtitle: 'Securities Trading Account Opening',
        khbutton: "Open an Account Now",
        yanzhengma: "Code",
        phoneinput: "Enter Mobile Number",
        vcodeinput: "Enter Verification Code",
        jiaoxue: "Online account opening teaching",
        khzb: "Preparation for Account Opening",
        idcard: "Identity Card",
        pass: "Passport",
        bankcard: "Cash Account",
        lxwm: "cs@qmis.com.hk",
        lxwm1: "Contact Us",
        ybcx: "Customer Services Hotline",
        jyrx: "Dealing Service Hotline",
        mfndzx: " Mainland Toll Free",
        dy: "Email Address",
        aftersecond: "s",
        success: "Login Successful",
        regetcode: "Resend",
        phoneinputp: "Please enter your mobile phone number!",
        vscodep: "Please enter the verification code!",
        zgdl: "China",
        zgxg: "Hong Kong,China",
        zgam: "Macau,China",
        adly: "Australia",
        jnd: "Canada",
        mlxy: "Malaysia",
        mg: "USA",
        xjp: "Singapore",
        xxl: "New Zealand",
        yg: "UK",
        qt: "Others",
        emailinput: "Enter Email Address",
		khtext1:'Account Opening Process is Fast and Easy :',
		khtext2:'Enter the Mobile Phone Number',
		khtext3:'Get and Enter the Verification Code',
		khtext4:'Read and Agree to the Agreement',
		khtext5:'Upload Personal Information and Documents',
		khtext6:'Complete the Questionnaire',
		khtext7:'Select Method of Account Opening',
		khtext8:'Account Opening Process is completed once the Background Check approved',
		khtext9:'Account Application',
		khtext10:'Mobile Number',
		khtext11:'Email Address',
        khtext12:'Enter Verification Code',
    },
    khlx: {
        grzh:"Individual Account",
        sczj:"Upload Documents",
        khqd:"Account Opening Channel",
        qsrkhqd1:"Please Choose",
        qsrkhqd:"Please Enter",
        wjyy:"Walk-in",
        qyzj:"Referral",
		hlw:"Website, Newspapers, Magazines",
        ktdzjy: "Electronic Trading Service",
        needktdzjy: "Require",
        noktdzjy: "Not Require",
        xgjmsfz: "HK Identity Card",
        gnrssfz: "PRC Identity Card",
        hzhfxgsfz: "Passport or non-HKIC",
        sfzm:'Personal Identification',
		qxzsfzm:'Please Choose',
		zp2M:'Size not exceed 2M',
        hz:'Passport',
		xgzm:'Front of EEP',
		xgfm:'Back of EEP',
		sfzzzm:'Front of ID Card',
		sfzzfm:'Back of ID Card',
		jscx:'Direct Marketing Opt-In',
		bjscx:'Direct Marketing Opt-Out',
		SMS:'SMS',
		Phone_dh:'Phone',
		Email_yx:'Email',
		Mail_yj:'Mail',


        khlx: "Account Nature",
        lxxz: "Account Nature",
        gr: "Individual Account ",
        zhzl: "Account Type",
        xjzh: "Cash Securities Account",
        dydz: "Email Address",
        dydzinput: "Please Enter",
        errordydzinput: "Please enter a valid email",
        shi: "Yes",
        fou: "No",
        picjzz: "Loading",
        choose1: "QMIS Securities and/or its Affiliates may use Client's Personal Data for direct marketing purposes.",
        choose4: "Please check (“✔️”) the relevant box(es) below to indicate your choice regarding the QMIS Securities’ use of your data for direct marketing as set out in the QMIS Securities’ Data Privacy Policy’s relating to the Personal Data (Privacy) Ordinance (“Ordinance”) (Chapter 486 of the Laws of Hong Kong) through any of the following channel(s):-",
        choose4_1: "",
        choose5: "The foregoing indicates that the Client agrees and acknowledges that the Client now has the option to receive direct marketing or/and information from QMIS Securities and/or its Affiliates and supersedes any choice made to QMIS Securities prior to Client\'s communication to the  \"Account Application Form – Brokerage Account\" available on the QMIS Financial’ Webpage or/and QMIS Securities’ Online Trading Platform.",
        choose6: "The Client understands that it may request changes to the relevant settings at any time through the QMIS Securities’ Online Trading Platform and other designated channels.",
        xiayibu: "Next"
    },
    jbxx: {
        zzyq1:'Self-Owned',
		zzyq2:'Live with Family',
		zzyq3:'Mortgaged',
		zzyq4:'Rented',
        dy1:'BY E-MAIL to Designated E-mail Address',
		dy2:'BY MAIL to Correspondence Address',
		dy3:'BY MAIL to Residential Address',
		dy4:'*HKD 20 for mail monthly statement / notice',
        tzfs:'Method of Communication',
		jdfs:'Delivery',
		qxzjdfs:'Please Choose',
        sm1:'Residential and/or Correspondence Address Proof (Copy)',
		sm2:'- Document should be issued within Three (3) Months from the date of the Application of the Securities Trading Account Opening',
		sm3:'- Bank Statement, Utilities Bill with the name and address of the relevant Account Holder shown and with the name of issuing organization and the issued date.',
		sm4:'3. Statements or correspondence issued by banks, licensed money lenders, insurance companies.',
        zzdzbt:'Please provide if difference from the Residential Address',
        zzdz_radio1:'Same as above',
		zzdz_radio2:'Different from above',
		tzzl:'Communication Details',
        swbhyy:'Please Enter',
        yyxz:"Language",
		qxzyyxz:"Please Choose",
        ddzm: "Address Proof",
		qscddzm: "Upload Document",
		yscddzm: "Upload Successful",
        zzyq: "Ownership of Residence",
		qsrzzyq1: "Please Enter",
		qsrzzyq: "Please Choose",
        address: "Correspondence Address",
        addressinput: "Please enter your Correspondence Address ( PO Box is not accepted )",
        grxinx: "Personal Particulars",
        zwxm: "Chinese Name",
        ywxm: "English Name",
        qshurzhongwenm: "Please enter your chinese name",
        qshruyingwenming: "Please Enter",
        dazhuanchengdu: "Post-Secondary",
        cal: "Title",
        xiansheng: "Mr.",
        nvshi: "Miss",
        taitai: "Mrs.",
        qxzchenghu: "Please choose gender",
        birth: "Date of Birth",
        birthplace: "Place of Birth",
        qsrbirthplace: "Please Enter",
        jiaoyuchengdu: "Highest Education Level",
        qxzjycd: "Please Choose",
        qfdd: "Place of Issue",
        qsrqfdd: "Please Enter",
        nationality: "Nationality",
        qsrnationality: "Please Enter",
        qsrnationality1: "Please Enter",
        jiaoyuchengdushi: "What is your education level",
        xiaoxuehuoyixia: "Primary School",
        zhongxuechengdu: "Secondary School",
		ftzw: '繁體中文',
		jtzw: '简体中文',
        yingwen: 'English',
        daxuehuoyishang: "University or above",
        fjsm1: "Client\'s Companion/Additional QMIS Securities’ Staff Arrangement (NOT Applicable to Client(s) Aged 65 or below, or Education Level above Primary 6)",
        fjsm1_1: 'As I am/(We are)：',
        zhangzhe: "Elderly ( Aged 66 or above ) ",
        jiaoyuchengduxiaoliu: "with Education Level ( Primary 6 or below ) ",
        khtbap: "Companion Arrangement",
        fjsm2: "I/(We) hereby acknowledge and understand that I/(we) have the right to accompany me/(us) in the process of opening a Securities Trading Account with my/our companion with QMIS Securities Limited ( “QMIS Securities” ) ( SFC CE Number : ARK249 ) to ensure I/(we) understand all contents of “Agreement for Securities Trading Account”, including the enclosure of Part 4 “Risk Disclosure Statement” and the relevant fees and charges to be charged.",
        lable3: "I /(We) am/(are) present with a companion whose name is",
        fjsm3: "(\"Companion\" relationship with me/(us) ",
        fjsm4: ")accompanying me/(us) during the account opening process, the companion is currently between 18 and 65 years old, has a Secondary School Education or Above, uses a communicative language during the presentation process and assists me/(us) to understand all the relevant documents with the knowledge and experience required.",
        fjsm5: "I/(we) hereby confirm that QMIS has strongly recommended that I/(we) attend this meeting with my/our companion in order to fully understand the content of all relevant documents and the risks involved in Securities investment. However, I/(we) confirm that I am/(we are) sufficiently competent to understand the above-mentioned matters relating to my/(our) application for account opening without the involvement of a companion.",
        lable4: "Additional Staff Arrangement (MUST be conducted at QMIS Securities’ Hong Kong office)",
        fjsm8: "I/(We) hereby acknowledge and understand that I am/(we are) entitled to have an additional QMIS Securities’ licensed intermediary to handle this Securities Trading Account opening process to enhance protection to me/(us).",
        fjsm6: "I/(We) would like an additional licensed intermediary of QMIS Securities to handle this account opening process and confirm that the application process for account opening is proceeding as usual. ( Name of the QMIS Securities Licensed Intermediary:",
        zhiwei: "Job Position:",
        fjsm7: "Despite the fact that I am/(we are) entitled to do so, I/(we) confirm that I/(we) do not need to have another QMIS Securities’ licensed intermediary to handle this process. ",
        queding: "CONFIRM",
        quxiao: "CANCEL",
        qingshurutbxm: "Please Enter",
        qingtianxie: "Please Enter",
        tanxiefjsm: "Please fill in the Additional Declaration",
        fjsm: "Additional Declaration",
        sfxx: "Identity Information",
        sfzmwjzl: "Identity Information",
        qxzsfzmwjzl: "Please select the type of Identification document",
        xgjmsfz: "Hong Kong Identity Card",
        gnrssfz: "People's Republic of China Resident Identity Card",
        hzhfxgsfz: "Passport or non-Hong Kong Identity Card",
        sfz: "Identity Card Number",
        huzhao: "Passport Number",
        gj: "Nationality",
        swbh: "Taxpayer Identification Number",
        bsdq: "Country of Tax Residence",
        rmyswbh: "If a TIN is unavailable, please choose the appropriate reason A,B or C",
        causeA: "Reason A - The jurisdiction where the account holder is a resident for tax purposes does not issue TINs to its residents.",
        causeB: "Reason B - The account holder is unable to obtain a TIN. Explain why the account holder is unable to obtain a TIN if you have selected this reason.",
        causeC: "Reason C - TIN is not required. Select this reason only if the authorities of the jurisdiction of residence do not require the TIN to be disclosed.",
        qxzwftgswbhdly: "Please select the reason why the tax number cannot be provided",
        chooseB: "Explain why the account holder is unable to obtain a TIN if you have selected Reason B.",
        zzdz: "Residential Address (Chinese)",
        zzdz1: "Residential Address (English)",
        djwl: "Trade confirmations and Statements",
        djyyxz: "Language",
        danjuways: "Method of delivery",//Select
        dydz: "By email",
        bscdz: "By Post : Residential (A postage fee of US 10 will be imposed per month)",
        bscdzf: "A postage fee of US 10 will be imposed per month",
        yhzh: "Hong Kong Bank Account",
        yhmc: "Bank Name",
        zhmc: "Account Name",
        zhhm: "Account Number",
        fz1: "Remarks : The account name must be the same as the account holder.",
        qsrsfzhm: "Please Enter",
        qsrhzhm: "Please enter your passport number",
        qsrgj: "Please enter nationality",
        qsrswbh: "Please Enter",
        qsrbsdq: "Please Enter",
        qsrly: "Please enter the reason why you cannot obtain the tax number",
        qsrzjdz: "Please enter your residential address (Chinese) ( PO BOX is not accepted )",
        qsrzjdz1: "Please enter your residential address (English) ( PO BOX is not accepted )",
        qxzdjyy: "Please select document language",
        qxzdjwldz: "Please Select method of delivery",
        qsryhmc: "Please Enter",
        qsrzhmc: "Please Enter",
        qsrzhhm: "Please Enter",
        qxuanzeriqi: "Please Choose",
        swbhjstitle: "Tax number description",
        swbhjs1: "For the tax resident of Hong Kong/The People's Republic of China, the Taxpayer Identification Number (TIN) is the Hong Kong Identity card Number/The People's Republic of China Identity Card Number.",
        swbhjs2: "If the country of tax residence is neither Hong Kong nor Mainland China, please state your Tax Residence and TIN. If TIN is unable to provide, please explain the reason.",
		swbhj1:'For HKID number, input all numbers and letters excluding the bracket symbol, e.g. A1234567.',
		swbhj2:'For China resident ID number, input all numbers and letters.',
		swbhj3:'For Passport number or non-HK resident ID number, input all numbers and letters excluding symbols, e.g. AB123Y.',
        xiayibu: "Next"
    },
    sgzk: {
        nq_1:'  Years',
        year_1:' Years',
        year_2:' Years ',
        month_1:' Months',
        jyzk:'Employment Status',
        gzmc:'Employer Name',
        qsrgzmc:'Please Enter',
        gsdz:'Business Address',
		qsrgsdz:'Please Enter',
        hy:'Occupation',
		qsrhy:'Please Choose',
        zc:'Job Position',
		qsrzc:'Please Enter',
        fwnz:'Years of Service',
		qsrfwnz:'Please Choose',
        fwyz:'Months of Service',
		qsrfwyz:'Please Choose',

        sglx: "Employment Type",
        sg: "Employed",
        qz: "Full-Time Employed",
		jz: "Part-Time Employed",
        zg: "Self-Employed",
        tx: "Retired",
        qt: "Others",
        gsmc: "Name of Employer",
        gsxz: "Business Nature",
        guzhu: "Please enter the company name",
        qsrgz: "Please enter employer",
        ywxz: "Please select or enter the business nature",
        zhiwei: "Position",
        xuzzhiwei: "Please select or enter the position",
        xuzzhiweie: "Please enter the position",
        gujiahuodiqu: "Country/Region",
        qingxuangjhdq: "Please select or enter country or region",
        qsrsgsj: "Please select employment time",
        qsrzgzk: "Please enter self - employment status",
        qsrqtzk: "Please Enter",
        xiayibu: "Next",
        sgsj: "Employed Time",
        ywxz1: "",
        ywxz2: "Admin & HR",
        ywxz3: "Banking / Finance",
        ywxz4: "Beauty Care / Health",
        ywxz5: "Building & Construction",
        ywxz6: "Design",
        ywxz7: "E-commerce",
        ywxz8: "Education",
        ywxz9: "Hospitality / F&B",
        ywxz10: "Information Technology",
        ywxz11: "Insurance",
        ywxz12: "Management",
        ywxz13: "Manufacturing",
        ywxz14: "Marketing/Public Relations",
        ywxz15: "Media & Advertising",
        ywxz16: "Medical Services",
        ywxz17: "Merchandising & Purchasing",
        ywxz18: "Professional Services",
        ywxz19: "Property / Real Estate",
        ywxz20: "Public / Civil",
        ywxz21: "Effluent Handling and Waste Management",
        ywxz22: "Sales, CS & Business Development",
        ywxz23: "Sciences, Lab, R&D",
        ywxz24: "Transportation & Logistics",
        xuzzhiwei1: "Trainee",
        xuzzhiwei2: "Assistant",
        xuzzhiwei3: "Clerk",
        xuzzhiwei4: "Manager",
        xuzzhiwei5: "Executive",
        xuzzhiwei6: "Management",
        xuzzhiwei7: "Director",
        // xuzzhiwei8: "Vice President",
        // xuzzhiwei9: "Department Manager",
        // xuzzhiwei10: "Regional Manager",
        // xuzzhiwei11: "Regional Manager",
        qingxuangjhdq1: "China",
        qingxuangjhdq2: "Hong Kong, China",
        qingxuangjhdq3: "Macau, China",
        qingxuangjhdq4: "Malaysia",
        qingxuangjhdq5: "Singapore",
        qingxuangjhdq6: "Australia",
        qingxuangjhdq7: "UK",
        qingxuangjhdq8: "USA",
        qingxuangjhdq9: "Canada",
        qingxuangjhdq11: "New Zealand",
        qingxuangjhdq10: "Taiwan, China",
        qxztztime: "Please select"
    },
    cwzk: {
        srly:"Source of Income",
		qxzsrly:"Please Choose",
		gz:"Salary / Wages",
		cx:"Savings / Family",
		zj:"Rental",
		gx:"Dividend / Interest ",
		ywtl:"Business Profit",
		mnzsr:"Annual Income (HKD)",
		qxzmnzsr:"Please Choose",
		wsr:"No Income",
        zclb:"Asset Type",
		qxzzclb:"Please Choose",
        xj:"Cash / Bank Deposit ",
		fdc:"Land and Property",
		gsgf:"Company Shares",
		yc:"Inheritance ",
		sszq:"Foreign Currency / Precious Metals",
		jj:"Funds ",
		zq:"Bonds / Debentures",
		whzj:"Foreign Exchange",
        zzcjz:"Estimated Total Net Worth (HKD)",
		qxzzzcjz:"Please Choose",
		tzgk:"Investment Profile",
		tzmb:"Investment Objectives",
		qxztzmb:"Please select an investment objective",
        gxsy:'Dividend Yield',
		zbzz:'Capital Appreciation',
		zxtz:'Long-Term Investment',
		dxtz:'Short-Term Trading ',
		dctz:'Hedging Investment',
        fxcsnl:'Risk Tolerance',
		qxzfxcsnl:'Please Choose',
        dfx:'Low',
		zfx:'Medium',
		gfx:'High',
        tzlxjjy:'Investment Experience & Products Type',
		kdxyx:'Can choose more than one option',
        cbbc:'Securities / ETFs',
		etf:'Bonds',
		futures:'Mutual Funds / Unit Trusts',
		commodities :'Derivatives',
		trust:'Fixed Income Securities',
		forex:'Structured / Leveraged Products',
		reits:'REITS',
		yscp:'Knowledge of Derivatives',
        yscp_1:'Do you have the adequate knowledge of “Derivatives and Structured Products” which includes its “Nature and Risks” ?',
		yscp_2:'Please state whether the Client acquired knowledge on “Derivatives and Structured Products” by the following ways ?  ',
		yscp_3:'Undergoing relevant training or attending courses or seminars on “Derivatives and Structured Products”',
		yscp_4:'Current employment and/or previous work experience for which relates / related to “Derivatives and Structured Products”',
		yscp_5:"Client's relevant investment experience (with At Least 5 Transactions in the Recent 3 Years in products)",
        you:'Yes',
		noyou:'No',

        cwzk: "Financial Profile",
        mnsr: "Annual Income (HKD)",
        zcjz: "Net Asset Value (HKD)",
        zjly: "Source of Income",
        chuxu: "Savings",
        jiating: "Family",
        yyyl: "Trading Profits",
        zjsr: "Rental Income",
        daikuan: "Loan",
        qita: "Others Source of Income",
        qsrqita: "Please specify",
		qtzi:'Others',// Source of Income
        zjlyother: "Please enter other sources of funding",
        tzmb: "Investment Objectives",
        tzmbsm: "Your choice below will determine which products you will be able to trade. Please select the appropriate option.",
        zbzz: "Capital Appreciation",
        touji: "Speculation",
        zhuanqushouru: "Generating Income",
        duichong: "Hedging",
        tzmbother: "Please enter other investment objectives",
        tzmbotherww: "Others",// Investment Objectives
        planother: "Others",// Investment Plan
        inputplanother: "Please enter other investment plans",
        tzjh: "Investment Plan",
        shijianduoxuan: "Investment Plan",
        duanqi: "Short Term",
        zhongqi: "Medium Term",
        changqi: "Long Term",
        timeother: "Please enter other investment plans",
        tzjy: "Investment Experience",
        touzijingyanxuanze: "Please Choose",
        years: "Years",
        year: "",
        over10year: ">10",
        qhqq: "Futures/Options",
        jijin: "Funds",
        zhaiquan: "Bonds",
        wtzjy: "None of the above",
        tzjyother: "Others",// Investment Experience
        qxztztime: "Please Choose",
        qxzmnsr: "Please select annual income",
        qxzzcjz: "Please select net asset value",
        qxzzjly: "Please Choose",
        qsrqtzjly: "Please choose another source of funding",
        qxztzmb: "Please Choose",
        qsrqttzmb: "Please enter other investment objectives",
        qxztzjh: "Please select investment plan",
        qsrqttzjh: "Please enter other investment plans",
        qxztzjy: "Please Choose",
        qsrqttzjy: "Please enter other investment experience",
        xiayibu: "Next"
    },
    khsm: {
        wenti_1_1:'No ( Please specify )',
		wenti_1_2:'Name of Ultimate Beneficial Owner',
		wenti_1_3:'Please Enter',

		wenti_3_1:'Licensed Corporation / Registered Institution Name',
		wenti_3_2:'Job Title',
		wenti_3_3:'SFC CE Number',
		wenti_3_4:'Employer SFC CE Number',
		wenti_3_5:'Please Enter',
		wenti_3_6:'Please Enter',
		wenti_3_7:'Please Enter',
		wenti_3_8:'Please Enter',

		wenti_4_1:'Name of Director OR Employee',
		wenti_4_2:'Please Enter',

		wenti_5_1:'Spouse Name',
		wenti_5_2:'Please Enter',
		wenti_5_3:'Account Number',
		wenti_5_4:'Please Enter',

		wenti_7_1:'Account Name',
		wenti_7_2:'Please Enter',
		wenti_7_3:'Account Type',
		wenti_7_4:'Please Enter',

        wenti_a_1:'A. The Client is required to read carefully and acknowledge in detail to the',
		wenti_a_2:'Agreement for Securities Trading Account',
		wenti_a_3:'Risk Disclosure Statement',
		wenti_a_4:'Privacy Data Policy',
		wenti_a_5:'FATCA and CRS Policies of QMIS Securities Limited',
		wenti_a_6:'Hong Kong Investor Identification Regime',
		wenti_a_7:'Over-the-Counter Securities Trading Risk Disclosure Statement',
		wenti_b:'B. The Client acknowledges that the signature specimen shall be recorded on QMIS Securities. QMIS Securities may execute various trading instructions under this signature specimen in future and the Client shall be solely responsible for such instructions.',
		qs:'Signature',
		khqs:'Client\'s Signature',
		wc:'CONFIRM',
		qc:'CANCEL',


        wenti_1:'Are you the “Ultimate Beneficial Owner” (“UBO”) in relation to this Account ?(i.e. Are you acting for your own account and NOT for a “Third Party” ? )',
		wenti_2:'Is the Client and/or the Ultimate Beneficial Owner (UBO) of the Account, or the Client\'s Spouse, Partner, Child, Parent, Spouse or Partner of the Client\'s Child, or a Closely Associate with the Client entrusted or has been entrusted with a Prominent Public Function, which includes a Head of State, Head of Government, Judicial or Military Official, Senior Executive of a State-Owned Corporation or an Important Political Party Official ?  ',
		wenti_3:'Is the Client an employee of a Licensed Corporation under the “Securities and Futures Ordinance” (“SFO”), OR a Registered Institution under the “Banking Ordinance” (“BO”) (whether the Client is currently a “SFC Licensed Representative” (“LR”) OR “HKMA Registered Person” (“RP”) or not) ?',
		wenti_4:'Is the Client, the Ultimate Beneficial Owner (UBO), and/or Ultimate Instructor has any relationship with any Director or Employee of QMIS Securities or its Affiliates ? ',
		wenti_5:'Is the Client, either alone or with the Client\'s Spouse, in control of Thirty-Five Percent (35%) or More of the “Voting Rights” of any Corporation Account of QMIS Securities or its Affiliates ? ',
		wenti_6:'Is the Client\'s Spouse having an Cash and/or Margin Account(s) with QMIS Securities or its Affiliates ?',
		wenti_7:'Is the Client maintained a Cash and/or Margin Account(s) with QMIS Securities or its Affiliates ?',
		wenti_8:'Does the Client (i.e. the “Primary Joint Account Holder”) and/or the “Secondary Joint Account Holder” a “U.S. Citizen” (i.e. holding a “U.S. Passport”) or residents of the U.S. for tax purposes (i.e. holding “U.S. Green Card”) ? ',
        wenti_9:'Is this account operated by an “Authorized Person(s)” ?',
		wenti_9_1:'I / (We) hereby declare that I / (we) shall be fully responsible for any instruction given or purported to be given by the Authorized Person(s) (including but not limiting to the “Verbal Instruction(s)” and/or “Written Instruction(s)”), and I / (we) shall fully indemnify QMIS Securities against all damages, losses, costs and expenses whatsoever incurred as a result of any act, inactivity or omission of the Authorized Person(s).',
		wenti_9_2:'When I / (we), the Authorized Person(s) listed, I / (we) accept the aforementioned Client\'s Authorization to become the Account’s Authorized Person(s). I / (We) hereby agree that I / (we) shall be fully responsible for all liabilities arising from my / (our) relevant Account(s) with QMIS Securities and I / (we) shall fully indemnify QMIS Securities against all damages, losses, costs and expenses whatsoever incurred as a result of any act, inactivity or omission of the Account Holder(s) and/or myself / (ourselves).',
		sqrsmc:'Name of Authorized Person',
		sqrsid:'ID / Passport Number of Authorized Person',
		zhcyr:'Relationship Between Authorized Person and Account Holder',
		sqrsphone:'Authorized Person Contact Number',
        qsrsqrsmc:'Please Enter',
		qsrsqrsid:'Please Enter',
		qsrzhcyr:'Please Enter',
		qsrsqrsphone:'Please Enter',

        messagea:'A. Name of the applicant',
		messageb:'B. Bank account number of the applicant',
		messagec:'C. Transfer amount',
		messaged:'D. Bank account number of beneficiary (QMIS Securities Limited)',
        khsm: "Declaration",
        qxzshf: "Please choose yes or no",
        qscgzsmtytp: "Please upload the employer's written consent",
        q1: "1.Are you the ultimate beneficial owner in relation to the account ?",
        shi: "Yes",
        foutigxx: "No（Please specify）",
        mingcheng: "Name",
        mingchenginput: "Please enter the owner's name",
        idcardpassnum: "ID Card/Passport No",
        idcardpassnuminput: "Please Enter",
        address: "Correspondence Address",
        addressinput: "Please enter the correspondence address of the Ultimate Beneficial Owner ( PO Box is not accepted )",
        q2: "2.Are you a relative of an employee or agent of QMIS Securities Limited (\"QMIS Securities\"), its Parent Co. or Associated Co. ?",
        // shitigxx: "Yes",
        shitigxx: "Yes（Please specify）",
        fou: "No",
        guyudailirenname: "Name of employee/agent",
        guyudailirennameinput: "Please enter the Name of employee/ agent",
        guanxi: "Relationship",
        guanxiinput: "Please Enter",
        q3: "3.Are you an employee or agent of a licensed corporation or registered institution with SFC, or other financial institutions ?",
        jigoumincheng: "Name of institution",
        jigouminchenginput: "Please enter the name of the institution",
        guzhushumiantongyi: "Your employer's written consent",
        shangchuantupian: "(upload picture)",
        dianjixuanzetupian: "Click to select upload image",
        tupianmiss: "The picture is lost",
        q4: "4.Are you a Director or shareholder of any listed company, foreign public figures e.g. senior government officials, political party leaders, religious leaders, etc. or their family members ?",
        qingtigongxiangqing: "Please Enter",
        q5: "5.Do you hold other accounts with QMIS Securities ( including accounts held by person related with you ) ?",
        accountnum: "Account number",
        accountnuminput: "Please enter your account number",
        accountname: "The name of the account",
        accountnameinput: "Please enter the account name",
        q6: "6.Are you citizens or residents of the USA for tax purposes ? ( Note: Due to US tax reporting requirements, US persons’ accounts require special approval )",
        querenjiqianshu: "Client Declaration and Signature",
        qianshu1: "The information contained in this Account Application Form (hereinafter referred to as \"the Application Form\") is true and accurate. You are obliged to notify QMIS Securities of any material change to the relevant information within Seven (7) calendar days commencing on the Effective Date. QMIS Securities reserves the right to contact any person at any time, including the Client's banks, brokers or credit agencies, to verify any information contained in the Application Form.",
        qianshu1a: "I hereby acknowledge and confirm that",
        qianshu2: "A.You confirm that you have received the ",
        qianshu3: "  which was provided by QMIS Securities in the language (English or Chinese) and have read and understood the Terms and Conditions of the Agreement.",
        qianshu3a: "\"(and the schedules, appendices and annexes thereto, if any)\"",
        qianshu3b: ", and I accept and agree to be bound by them;",
        qianshu4: "Agreement",
        qianshu1b: "B. You confirm that QMIS Securities has been provided a",
        qianshu1c: "The Risk Disclosure Statement was provided in a language of the client's choice (English or Chinese); and I was invited to read the ",
        qianshu5: " Risk Disclosure Statement ",
        qianshu2a: "(hereinafter referred to as \"the Risk Disclosure Statement\") in a language of your choice (English or Chinese) and has been invited to read the Risk Disclosure Statement, ask questions and seek professional and independent third party's advice (if you so wish) as set out in the Agreement.",
        qianshu2b: "C. You have read the ",
        qianshu6: " \"Notice of Customer on the Personal Data (Privacy) Ordinance\" ",
        qianshu2c: "set out in the Agreement, understand and agree to the terms of the \"Data Privacy Policy\" of the QMIS Securities.",
        qianshu7: "D. You acknowledge that the signature specimen will be recorded as my signature on QMIS Securities and QMIS Securities may execute various trading instructions under you for this signature specimen, and you shall be solely responsible for such instructions.",
        qianshu8: "e. I hereby acknowledge and confirm that:",
        qianshu8a: "(i) You completed and signed",
        qianshu9: " \"W-8BEN Form\" ",
        qianshu10: ", which prove that you are not a \"U.S. citizen\" and for U.S. stock trading purposes. (if applicable);",
        qianshu10a: "(ii) You completed the",
        qianshu11: " \"Individual Tax Residency Self-Certification Form (CRS-I (HK)\" ",
        qianshu12: ", which mean you have agreed to abide by the relevant terms and conditions.",
        xiayibu: "Next",
        nxyrzydxy: "You are required to read and agree in details of the \"Agreement for Securities Trading Account\" (hereinafter referred to as the \"Agreement\") and the \"Data Privacy Policy\" (hereinafter referred to as the \"Privacy Policy\") of QMIS Securities Limited (hereinafter referred to as the \"QMIS Securities\") in the below attachments.",
        bryydbtykhxy: "I hereby confirm that I have read and agreed to the above terms and conditions.",
        qydplease: "Please read all the attachments of Terms and Conditions."
    },
    fxpg: {
		fxpgtk:'Please read the statement relating to the Client Risk Profile Questionnaire.',
		qsrnr:'Please Enter',
		none:'NIL',
		dy_5:'≥ 5',
		xy_5:'< 5',
        fxpg_title:'Please select the most appropriate answer in the following Fifteen (15) Questions.',
		wt_1:'Please select your “Age Group” :',
		wt_2:'Please state your “Highest Education Level” :',
		wt_3:'Please state your “Total Net Assets” :',
		wt_4:'Please state your “Average Annual Income” in the past Three (3) Years :',
		wt_5:'Please describe your “Source of Income” :',
		wt_6:'Have you reserved ANY Funds / Assets (i.e. especially in the unforeseen events) for your “Monthly Household Expenses” ?',
		wt_7:'Please state your “Investment Experience” :',
		wt_8:'What is the “Percentage” of your “Net Worth Assets” that you will be set aside for “Investment Purpose” ?',
		wt_9:'Please state your “Investment Experience” in the following product types within the past Three (3) Years :',
		wt_10:'Do you have the adequate knowledge of “Derivatives and Structured Products” which includes its “Nature and Risks” ?',
		wt_11:'Which of the following statement is your view of “Principle Investment Objective” ?',
		wt_12:'What is the level of “Annual Volatility and Potential Returns” on financial investment portfolio which you generally can tolerate ?',
		wt_13:'Please state the maximum length of your “Expected Investment Horizon” :',
		wt_14:'What is your “Investment Goal” ?',
		wt_15:'Sometimes “investment losses” are permanent, sometimes they are prolonged, and sometimes they are short-lived.  How might you respond when you experience losses in your account ?',

        wt_1_1:'A. 18 to 24',
		wt_1_2:'B. 25 to 39',
		wt_1_3:'C. 40 to 54',
		wt_1_4:'D. 55 to 64',
		wt_1_5:'E. 65 or above',

        wt_2_1:'A. Not Applicable',
		wt_2_2:'B. Primary or below',
		wt_2_3:'C. Secondary or Post-Secondary',
		wt_2_4:'D. University or above / Professional Qualification (on Finance Related Disciplines)',
		wt_2_5:'E. University or above / Professional Qualification (on Non-Financial Related Disciplines)',

        wt_3_1:'A. Below HK$500,000',
		wt_3_2:'B. HK$500,000 to HK$999,999',
		wt_3_3:'C. HK$1,000,000 to HK$4,999,999',
		wt_3_4:'D. HK$5,000,000 to HK$7,999,999',
        wt_3_4_1:'E. HK$8,000,000 or above',
		wt_3_5:'TYPE(S) OF ASSETS (more than 1 optional)',
		wt_3_6:'Cash and Deposits',
		wt_3_7:'Securities',
		wt_3_8:'Property Investment(Other Than Client\'s Residential Address)',

        wt_4_1:'A. Below HK$100,000',
		wt_4_2:'B. HK$100,000 to HK$200,000',
		wt_4_3:'C. HK$200,001 to HK$500,000',
		wt_4_4:'D. HK$500,001 to HK$999,999',
		wt_4_5:'E. HK$1,000,000 or above',

		wt_5_1:'A. Stable, regular and/or recurrent income (i.e. The income is mainly from job / business / investment)',
		wt_5_2:'B. Retained and received stable regular income',
		wt_5_3:'C. Income not stable with fluctuation',
		wt_5_4:'D. Retired / Unemployed, but have savings on supports',
		wt_5_5:'E. No income',

        wt_6_1:'A. No preparation set aside for unforeseen events',
		wt_6_2:'B. Less than 6 months',
		wt_6_3:'C. 6 months to less than 12 months',
		wt_6_4:'D. 12 months to 24 months',
		wt_6_5:'E. 24 months or more',
		wt_6_6:'(Remarks : Those Funds / Assets shall be accessed and liquidated easily without penalty or with an acceptable penalty, such as (I) Cash, (II) Foreign Currencies, (III) Bullion, and/or (IV) Tradeable Securities etc.)',

		wt_7_1:'A. No experience',
		wt_7_2:'B. Less than 1 year',
		wt_7_3:'C. Between 1 year and 3 years',
		wt_7_4:'D. Between 3 years and 8 years',
		wt_7_5:'E. More than 8 years',

        wt_8_1:'A. 10% or below',
		wt_8_2:'B. Between 11% to 20%',
		wt_8_3:'C. Between 21% to 30%',
		wt_8_4:'D. Between 31% to 49%',
		wt_8_5:'E. Over 50%',
        wt_8_6:' (Remarks : “Net Worth Assets”- It excludes your “Self-Occupied Property”)',

        wt_9_1:'A. Foreign Currency Deposits / Precious Metals',
		wt_9_2:'B. Securities / Stocks / ETFs',
		wt_9_3:'C. Bonds (any kinds of)',
		wt_9_4:'D. Mutual Funds / Unit Trusts (any kinds of)',
		wt_9_5:'E. Derivatives (e.g. Options / Futures)',
		wt_9_6:'F. Fixed Income Securities (e.g. Government Bonds / Perpetual Bonds / Preferred Shares)',
		wt_9_7:'G. Structured / Leveraged Products (e.g. Equity Linked Investment, Credit Linked Note) ',
		wt_9_8:'H. Others (e.g. Private Equity / Hedge Fund)',
		wt_9_9:'(Remarks : If you have ANY knowledge of above product type(s) and number of transactions shall reach more than Five (5) times within the past Three (3) Years, for each product type you shall gain One (1) score, maximum shall gain Five (5) scores)',
		wt_9_10:'Year(s) of Experience',
		wt_9_11:'Please select year(s) of Experience',
		wt_9_12:'Number of transactions in the past 3 years',
		wt_9_13:'Please select number of transactions in the past 3 years',
		wt_9_14:'(Remarks : If you have ANY knowledge of above product type(s) and number of transactions shall reach more than Five (5) times within the past Three (3) Years, for each product type you shall gain One (1) score, maximum shall gain Five (5) scores)',

        wt_10_1:'A. YES, Please specify the means you gained of this knowledge.  (Remarks : You can choose more than One (1) option if applicable)',
		wt_10_2:' (I) Undergoing relevant training or attending courses or seminars on “Derivatives and Structured Products”;',
		wt_10_3:' (II) Current employment and/or previous work experience for which relates / related to “Derivatives and Structured Products”;',
		wt_10_4:'(III) Client\'s relevant investment experience (with At Least 5 Transactions in the Recent 3 Years in products) ;',
		wt_10_4_1:'(IV) Others (Please specify) : ',
		wt_10_5:'B. NO, I don\'t have ANY adequate knowledge on “Derivatives and Structured Products”.',
        
		wt_11_1:'A. Capital Preservation – I principally aim to keep investment loss at a minimum with not much concern on overall returns.',
		wt_11_2:'B. Income Oriented – I principally aim to achieve stable income or counteract inflation.',
		wt_11_3:'C. Income-and-Growth – I principally aim to achieve returns from both capital appreciation and stable income.',
		wt_11_4:'D. Growth Oriented – I principally aim to achieve returns that focus on capital appreciation.',
		wt_11_5:'E. Aggressive Growth – I principally aim to achieve higher return derived from the complex or leveraged investment products.',

		wt_12_1:'A. Less than 5% p.a. potential returns – I would not expect to bear volatile fluctuation on my investment.',
		wt_12_2:'B. Between 5% and 10% p.a. potential returns – I would like to acquire returns better than the rate of bank deposits.',
		wt_12_3:'C. Between 10% to 15% p.a. potential returns– I would like to acquire returns similar to the major stock market indexes.',
		wt_12_4:'D. Between 15% to 25% p.a. potential returns– I would like to acquire returns better than major stock market indexes.',
		wt_12_5:'E. More than 25% p.a. potential returns – My investment tactics is aggressive as to achieve a remarkably revenue.',

		wt_13_1:'A. Less than 1 year',
		wt_13_2:'B. Between 1 year and 3 years',
		wt_13_3:'C. Between 3 years and 5 years',
		wt_13_4:'D. More than 5 years',

		wt_14_1:'A. 10% or Below',
		wt_14_2:'B. Between 11% and 20%',
		wt_14_3:'C. Between 21% and 40%',
		wt_14_4:'D. Over 41%',

		wt_15_1:'A. I would sell my investment immediately if they suffered substantial declines.',
		wt_15_2:'B. Although declines in investment value make me uncomfortable, I would wait one to two quarters before adjusting my portfolio.',
		wt_15_3:'C. I can endure significant declines in the value of my investments and would wait at least one year before adjusting my  portfolio.',
		wt_15_4:'D. Even if my investments suffered a significant decline over several years, I would continue to follow my long-term investment strategy and not adjust my portfolio.',

		pfjg:"Total Score",
		bsx:"CONSERVATIVE ",
		wjx:"MODERATE",
		jhx:"BALANCED",
		zzx:"GROWTH",
		tqx:"AGGRESSIVE",
        bsx1:"Nature of “CONSERVATIVE”: Client prefers investment products of low uncertainty on returns or preserve capital ; and/or is equipped with limited / no knowledge and/or experience in financial investments .",
		wjx1:"Nature of “MODERATE”: Client is equipped with some knowledge and/or experience in financial investments ; and/or is willing to take modest risk so as to achieve returns better than bank deposits .",
		jhx1:"Nature of “BALANCED”: Client is equipped with the related investment knowledge and/or experience ; is willing to accept commensurable price fluctuation and takes a certain degree of risk so as to achieve returns in comparison with the major stock market indexes ; and possess good financial capability to deal with the loss incurred from the related investments .",
		zzx1:"Nature of “GROWTH”: Client is equipped with the related investment knowledge and/or experience ; is willing to accept relatively higher price fluctuations and takes relatively higher risk so as to achieve returns better than the major stock market indexes ; and possess solid financial capability to deal with the loss incurred from the related investments .",
		tqx1:"Nature of “AGGRESSIVE”: Client is demonstrated rather strong preference, knowledge and/or experience on high-risk, complex or leveraged products ; and/or possess substantial financial capability to deal with the loss incurred from the related investments.",
        khfx:'Attitude To Risk',
		benren:'All the above information provided by myself is True, Accurate and Complete, the above Assessment Result of the Risk Profile Questionnaire is precise and I hereby Agree and Confirm with such Assessment Result',
		benrenno:'I Disagree with the above Assessment Result of the Risk Profile Questionnaire, and believe the Risk Profile selected below, which is more Prudent and more suitable to describe myself. I hereby Confirm and Select the below Risk Profile shall be the Risk Profile level captured in QMIS Securities’ record.',
		miaoshu1:'** Please select the most appropriate Risk Profile which you think are more suitable to describe of you.',
		miaoshu2:'** Please notice that such assign level can ONLY be LOWER than the Risk Profile which assessed above.',
        fzqx:'Risk orientation',
		benrenyes:'I have read and agreed to accept the',
		assessment:'Declaration Statement relating to the  Client Risk Profile Questionnaire.',
		fxqxwj:'Client Risk Profile Questionnaire (Individual)',



        qxzyx: "Please select an option",
        fxpg: "Risk Profile Questionnaire for Individuals",
        title: "This questionnaire is designed to assess the risk tolerance and attitude of typical investors and assist our clients to understand their general risk profiles for the purpose of investment suitability assessment. This questionnaire should be completed by the designated client who makes investment decisions for and in the best interests of the account holder and is specified in the corresponding client agreement with us.",
        q1: "Q1.What is your age?",
        q2: "Q2.What is your education level?",
        q2A: "A. Primary level or below",
        q2B: "B. Secondary level",
        q2C: "C. Tertiary/University level",
        q3: "Q3.How many years of experience do you have with investment products the value of which can fluctuate (including 'buy and hold' and active trading)? Investment products the value of which can fluctuate could include, for example stocks, unit trusts, foreign currencies, commodities, structured investment products, warrants, options, futures, investment-linked insurance plans.",
        q3A: "A. No experience or Less than 1 year",
        q3B: "B. Between 1 and 3 years",
        q3C: "C. Over 3 years",
        q4: "Q4.Do you have any investment experience or knowledge of the below products? (You may select more 1 option)",
        q4A: "A. Cash, Deposits, Certificates of Deposit, capital protected products, HKSAR Government Bond.",
        q4B: "B. Stocks, Bonds, Equity or Bond Funds (including Mandatory Provident Funds, but excluding money market funds).",
        q4C: "C. Options, futures, warrants, hedge funds and other structured products such as equity linked note and OTC stocks.",
        q5: "Q5.Over a period of time the value of investments can rise and fall, this is called fluctuation. Generally, the higher the investment risk the higher the potential fluctuation but also the higher the potential returns. On the other hand, the lower the investment risk the lower the potential fluctuation but also the lower the potential returns. What level of fluctuation would you generally be comfortable with?",
        q5A: "A. Fluctuates under -30% and over +30%",
        q5B: "B. Fluctuates between -30% and +30%",
        q5C: "C. Fluctuates between -15% and +15%",
        q6: "Q6.How much of your investments would you require to liquidate to meet liquidity need for an unforeseen event? ",
        q6A: "A. I would not have to sell any of my investments.",
        q6B: "B. I would sell no more than 30% of my investments.",
        q6C: "C. I would sell more than 30% but less than 50% of my investments.",
        q6D: "D. I would sell more than 50% of my investments.",
        q7: "Q7.It is generally true that the longer the investment horizon, the higher the risk an investor can tolerate, and the values of investment products? Please refer to Question 3 for examples of such products.",
        q7A: "A. Over 3 years",
        q7B: "B. Between 1 and 3 years",
        q7C: "C. Less than 1 year",
        sumscore: "Total score",
        xiayibu: "Next",
        mzsm: "Disclaimer",
        mzsm1: "1. The results of this questionnaire are derived from the information that you have provided to QMIS Securities and on certain generally accepted assumptions and reasonable estimates. Calculations and values used in this questionnaire are used for illustration purpose only. The Group accepts no responsibility or liability as to the accuracy or completeness of the information containing in this questionnaire and/or the results.",
        mzsm2: "",
        mzsm3: "2. This questionnaire and the results only serve as a reference for your consideration, and are not an offer to sell or a solicitation for an offer to buy any financial products and services and they should not be considered as investment advice or recommendation.",
        mzsm4: "3. Please be reminded that any failure to fully disclose all or any of your personal circumstances (e.g. financial situation), inaccurate, incomplete or outdated information may affect our assessment of your attitude and capacity for investment risks. If there is any change in circumstances which may affect your answer(s) to any question in this questionnaire, we strongly recommend that you should complete this questionnaire again.",
        mzsm5: "",
        fxcsnlfx: "Risk Tolerance Analysis",
        fxcscd: "Risk Tolerance Level",
        dfx: "Low Risk",
        zfx: "Medium Risk",
        gfx: "High Risk",
        tzzdybtz: "You are classified as",
        phx: "Balance",
        jqx: "Aggressive",
        fx1: "You are willing to accept low risks.In return,you understand that you will receive low returns.",
        fx2: "You are willing to accept medium risks in exchange for some potential returns over the medium to long term.",
        fx3: "You are willing to accept very high risks to maximize your potential return over the long term.You understand that you may lose a sighificant part or all of your capital.",
        nxyrzydxy: "You should read and accept all the attachments in below \"Client's Agreement\" and \"Data Privacy Policy\".",
    },
    wjsc: {
        sflx: "Types of identity",
        type1: "Hong Kong residents",
        type2: "People in the domestic",
        type3: "foreigners",
        scdzzmwj: "Please upload the address proof",
        zmwjshuoming: "Valid proof of address is document, bill or correspondence is issued within the last 3 months from the application date by any of the organizations listed below. The document should include the name and address of the applicant, the name of issuing organization and the issue date:",
        zmwj1: "(1)Bills or invoices issued by utility companies (water, electricity, towngas, etc).",
        zmwj2: "(2)Landline telephone, mobile phone, internet service bills.",
        zmwj3: "(3)Statements or correspondence issued by banks, licensed money lenders, insurance companies.",
        piclimit: "Size not exceed 2M",
        djsctupian: "Click to select upload image",
        djzmtp: "(The Address Proof)",
        scxgsfzzfm: "Please upload the Front page/Back page of Hong Kong Identity Card",
        xgsfztp0: "(Front page of Hong Kong Identity Card)",
        xgsfztp1: "(Back page of Hong Kong Identity Card)",
        tupianmiss: "The picture is lost",
        scsfzzfm: "Please upload the Front page/Back page of Identity Card",
        sfzzm: "(Front page of Identity Card)",
        sfzfm: "(Back page of Identity Card)",
        scxgtxzzfm: "Please upload the Front page/Back page of Hong Kong pass",
        xgsfzzm: "(Front page of Hong Kong pass)",
        xgsfzfm: "(Back page of Hong Kong pass)",
        schz: "Please upload the passport",
        hztp: "(passport)",
        xiayibu: "Next",
        a1: "",
        a2: "",
        a3: "",
        a4: "",
        a5: "",
        a6: "",
        a7: "",
        a8: ""
    },
    ktzh: {
        yh_1:'The Hongkong and Shanghai Banking Corporation Limited',
		yh_2:'Hang Seng Bank Limited',
		yh_3:'Bank of China (Hong Kong) Limited',
		yh_4:'Industrial and Commercial Bank of China (Asia) Limited',
		yh_5:'CTBC Bank Co., Ltd. (Hong Kong Branch)',
		yh_6:'Hong Kong Interbank Clearing Limited',
        yh_title_1:'A/C No ：',
		yh_title_2:'SWIFT Code ：',
		yh_title_3:'Account Name ：',
		yh_title_4:'Bank Address ：',
		hkd: 'HKD',
        zhck:'Funds Deposit',
		yhmc:'Bank name',
		yhdm:'Bank Code',
        qmisents1:"Client Account",
		hkopen:'Document has been successfully uploaded',
		hkbs:'Please select one of the account opening methods',
        khfs: "Select one of the account opening methods",
        qtgzzfs: "Please upload the transaction receipt for our record.",
        qmis: "QMIS Securities Limited - Client",
        qmisclient: "QMIS Securities Limited - Client Account",
		qmisent: "QMIS Securities Limited - Clients' Account",
		qmisents: "QMIS Securities Limited - Clients Account",
        type1: "By Post",
        type2: "Appointment",
        type3: "Cheque",
		type4: "Online",
        zzje: "Transaction amount",
        hdbzhb: "or equivalent",
        skyh: "Bank",
        hfyh: "The Hongkong and Shanghai Banking Corporation Limited",
        zhhm: "Account Number",
        yhdz: "Bank address",
        skyhdh: "Bank Code",
        skhkmc: "Account Name",
        dzhb: "Multi-Currency",
        dzmy: "HKD & USD",
        address1: "1 Queen's Rd Central, Hong Kong",
        zsyybdfk: "(For local only)",
        zgxtyh: "CTBC Bank Co., Ltd. (Hong Kong Branch)",
        address2: "Room 2801, 28th Floor, Room 2104-10, 21st Floor, International Finance Center Phase 2, 8 Finance Street, Central, Hong Kong",
        address21: "International Finance Center Phase 2, 8 Finance Street,",
        address22: "Central, Hong Kong",
        zgyh: "Bank of China (Hong Kong) Limited",
        gangyuan: "HKD",
        waibi: "Multi-Currency",
        rmbjmy: "RMB & USD",
        address3: "Bank of China Tower, 1 Garden Road, Central, Hong Kong",
        gyyz: "Industrial and Commercial Bank of China(Asia) Limited",
        address4: "33/F, ICBC Tower, 3 Garden Road, Central, Hong Kong",
        sczzsj: "Upload the Transaction Receipt",
        dianjixuanzetupian: "Click to select upload image",
        zzsjtp: "(The transaction receipt)",
        tupianmiss: "The picture is lost",
        qsczzsj: "Please upload the transaction receipt for our record.",
        qlyyxsy: "Please be reminded that",
        sy1: "1. The deposit should be transferred by a bank account in Hong Kong whereas the applicant is the account holder.",
        sy2: "2. The deposit should be transferred from the same bank account provided during the application process.",
        sy3: "3. Bank charges of Interbank Transfer and Telegraphic Transfer shall be borne by the clients and will be deducted from the Deposit Amount.",
        sy4: "4. We only accept deposit by account transfer. Cash deposit and other payment methods are not acceptable.",
        sy5: "5. The following details should be displayed in the bank-in receipt:",
        yyrq: "Appointment date",
        yysj: "Please select a specific time for the appointment.",
        zpxmzyxyq: "The cheque should fulfill the below requirements:",
        yq1: "1.The cheque issuer should be the same as the account applicant.",
        yq2: "2.The cheque account number should be the same as the bank account provided.",
        yq3: "3.The amount should be at least HKD10,000 or equivalent.",
        yq4: "4.The cheque is payable to \"QMIS Securities Limited - Client Account\".",
        yq5: "5.Signature should be identical with the signature on the application form.",
        yq6: "6.The cheque should be issued by a Hong Kong licensed bank.",
        apyjdyxdz: "Please prepare a cheque and mail to the following address:",
        dz1: "QMIS Securities Limited - Client Account",
        dz2: "Unit 2104, 21/F, Infinitus Plaza, 199 Des Voeux Road Central, Sheung Wan, HongKong",
        dz3: "(Attention To: Customer Services Department)",
        dz4: "QMIS Securities Limited - Client",
        dz5: "QMIS Securities Limited - Clients Account",
        dz6: "QMIS Securities Limited – Client Account",
        qxzyyrq: "Please choose the date for the appointment.",
        qxzyysj: "Please select a specific time for the appointment.",
        qsczzsjtp: "Upload the Transaction Receipt",
        xiayibu: "CONFIRM",
        hsyh: "Hang Seng Bank Limited",
        address5: "83 Des Voeux Road Central, Hong Kong",
        ydkh1: "Please complete the account opening application according to the below procedures:",
        ydkh2: "Print",
        ydkh3: " this application form",
        ydkh4: "Provide signature in the signature column in the application form",
        ydkh5: "Prepare the copy of below documents:",
        ydkh6: "A. Front and back of ID card / passport",
        ydkh7: "B. Address proof within the latest three months",
        ydkh8: "C. Bank statement",
        ydkh9: "Arrange a witness to fill in the name and sign on the application form and copies of relevant documents",
        ydkh10: "Arrange deposit to our Company's bank account by one of the channel below:",
        ydkh11: "1. Transfer a minimum amount of HKD 10,000 (or equivalent). Please press ",
        ydkh12: "(here)",
        ydkha12: " for details.",
        ydkh13: "A. The deposit should be transferred by a bank account in Hong Kong whereas the applicant is the account holder.",
        ydkh14: "B. The deposit should be transferred from the same bank account provided during the application process.",
        ydkh15: "C. Handling fee may be imposed by some of the banks for interbank transfer.",
        ydkh16: "D. We only accept deposit by account transfer. Cash deposit abd other payment methods are not acceptable.",
        ydkh17: "E. The following details should be displayed in the bank-in receipt:",
        ydkh18: "2. Prepare a cheque with a minimum amount of HKD 10,000 (or equivalent). Please press ",
        ydkh19: "A. The cheque issuer should be the same as the account applicant.",
        ydkh20: "B. The cheque account number should be the same as the bank account provided.",
        ydkh21: "C. The amount should be at least HKD 10,000 or equivalent.",
        ydkh22: "D. The cheque is payable to \"QMIS Securities Limited – Client Account\".",
        ydkh23: "E. Signature should be identical with the signature on the application form.",
        ydkh24: "F. The cheque should be issued by a Hong Kong licensed bank.",
        ydkh25: "Please mail the above documents to our office address as below:",
        warning_left: "Booking can be made 3 months in advance",
        warning_right: "Hong Kong Holiday"
    },
    khfinish: {
		khwc:'Account Opening Completed',
        success: "Submission Completed",
        dearuser: "Dear Valued Customer",
        a1:"Your account opening application has approved. ",
        a2:"You are currently the account holder. Please do not submit again.",
        a3:"Should you have any enquiries, please contact our Customer Services Hotline \nduring office hours.",
        f1: "Thank you for your application. Our Customer Services Department will contact you soon. ",
        f2: "Should you have any enquiries, please contact our Customer Services Hotline during office hours",
        f3: "Customer Services Hotline",
        f4: "Toll-Free Mainland China Hotline",
        f5: "Your account opening online application has been received.",
        f6: "Should you have any enquiries, please contact our Customer Services Hotline during office hours",
        f7: "Thank you for your ",
        f8: " application. Our Customer Services Department will contact you soon.",
        t1: "Thank you for your online application. Our Customer Services Department will contact you soon. ",
        t2: "Thank you for your appointment application. Our Customer Services Department will contact you soon. ",
        t3: "Thank you for your cheque application. Our Customer Services Department will contact you soon. ",
        t4: "Thank you for your by post application. Our Customer Services Department will contact you soon. "
    }
};
export default en;